import React from "react";
let Home = () => {
  document.title = "Home | Montuli Cafe";
  return <div></div>;
};
export default Home;
